module.exports = "https://static.wmbcdn.com/uniweb/images/96ffbb62ae843407638d3ab6dd23839d.svg";